module.exports = __webpack_public_path__ + "static/media/BackImg.8ade4b6e.svg";